module.exports = __webpack_public_path__ + "img/microphone-label.17864da7.svg";